function initMenu() {

    const MOBILE_MENU = document.getElementById('mobile-menu');

    if(MOBILE_MENU) {

        MOBILE_MENU.toggler = MOBILE_MENU.querySelector('.mobile-menu__toggler');
        MOBILE_MENU.content = MOBILE_MENU.querySelector('.mobile-menu-content');
        MOBILE_MENU.bg = MOBILE_MENU.querySelector('.mobile-menu-bg');
        MOBILE_MENU.back = MOBILE_MENU.querySelector('.mobile-menu-back');
        MOBILE_MENU.activeItem = null;

        if(MOBILE_MENU.toggler) {

            let timeline;

            timeline = gsap.timeline();

            MOBILE_MENU.toggler.lines = MOBILE_MENU.toggler.querySelectorAll('.mobile-menu__toggler__line');

            MOBILE_MENU.toggler.addEventListener('click', function() {

                MOBILE_MENU.classList.toggle('active', !MOBILE_MENU.classList.contains('active'));

                timeline.clear(true);

                if(MOBILE_MENU.classList.contains('active')) {


                    timeline.to(MOBILE_MENU.toggler.lines[0], {duration: 0.1, top: '10px', ease: 'power2.out'});
                    timeline.to(MOBILE_MENU.toggler.lines[2], {duration: 0.1, top: '10px', ease: 'power2.out'}, "<");
                    timeline.to(MOBILE_MENU.toggler.lines[1], {duration: 0.1, opacity: 0, ease: 'power2.out'},"<");
                    timeline.to(MOBILE_MENU.toggler.lines[0], {duration: 0.1, rotate: '45deg', ease: 'power2.out'});
                    timeline.to(MOBILE_MENU.toggler.lines[2], {duration: 0.1, rotate: '-45deg', ease: 'power2.out'}, "<");

                    timeline.to(MOBILE_MENU.bg, {duration: 0.2, scaleY: "100%", ease: 'power2.out'}, "<");
                    timeline.to(MOBILE_MENU.content, {duration: 0.2, autoAlpha: 1, ease: 'power2.out'});
                    if(MOBILE_MENU.activeItem) timeline.to(MOBILE_MENU.back, {duration: 0.2, translateY: "-10px" , ease: 'power2.out'}, "<");

                    document.body.style.overflow = 'hidden';
                } else {

                    timeline.to(MOBILE_MENU.content, {duration: 0.2, autoAlpha: 0 , ease: 'power2.out'});
                    if(MOBILE_MENU.activeItem) timeline.to(MOBILE_MENU.back, {duration: 0.2, translateY: "100%" , ease: 'power2.out'}, "<");

                    timeline.to(MOBILE_MENU.bg, {duration: 0.2, scaleY: "0%", ease: 'power2.out'});
                    timeline.to(MOBILE_MENU.toggler.lines[0], {duration: 0.1, rotate: '0deg', ease: 'power2.out'});
                    timeline.to(MOBILE_MENU.toggler.lines[2], {duration: 0.1, rotate: '0deg', ease: 'power2.out'}, "<");
                    timeline.to(MOBILE_MENU.toggler.lines[0], {duration: 0.1, top: '0px', ease: 'power2.out'});
                    timeline.to(MOBILE_MENU.toggler.lines[2], {duration: 0.1, top: '20px', ease: 'power2.out'},"<");
                    timeline.to(MOBILE_MENU.toggler.lines[1], {duration: 0.1, opacity: 1, ease: 'power2.out'},"<");
                    document.body.style.overflow = 'auto';
                }

            });

        }

        const MENU_LINKS = MOBILE_MENU.querySelectorAll('.mobile-menu-content__menu > .menu-item > a');

        if(MENU_LINKS) {

            for(let i = 0; i < MENU_LINKS.length; i++) {

                if(!MENU_LINKS[i].parentElement.classList.contains("menu-item-has-children")) continue;

                MENU_LINKS[i].addEventListener('click', function(e) {
                    e.preventDefault();

                    this.parentNode.classList.toggle('active');

                    if(this.parentNode.classList.contains("active")) {

                        MOBILE_MENU.activeItem = this.parentNode;

                        let timeline1 = gsap.timeline();

                        timeline1.to(MENU_LINKS, {duration: 0.1, translateX: "-10px", autoAlpha: 0, ease: 'power2.out'});
                        timeline1.to(this.nextElementSibling, {duration: 0.5, autoAlpha: 1, ease: 'power2.out'});
                        timeline1.to(MOBILE_MENU.back, {duration: 0.5, translateY: "-10px", ease: 'power2.out'}, "<");
                    }
                });
            }
        }

        if(MOBILE_MENU.back) {

            MOBILE_MENU.back.addEventListener('click', function() {

                let timeline1 = gsap.timeline();

                timeline1.to(MOBILE_MENU.activeItem.querySelector('.sub-menu-wrap'), {duration: 0.2, autoAlpha: 0, ease: 'power2.out'});
                timeline1.to(MENU_LINKS, {duration: 0.1, translateX: "0px", autoAlpha: 1, ease: 'power2.out'});
                timeline1.to(MOBILE_MENU.back, {duration: 0.1, translateY: "100%", ease: 'power2.out', stagger: 0.05}, "<");
                // timeline1.to(MOBILE_MENU.activeItem, {duration: 0.1, className: "-=active", ease: 'power2.out'}, "<");
                MOBILE_MENU.activeItem.classList.remove('active');
                MOBILE_MENU.activeItem = null;

            });

        }
    }

    /**
     * Sticky menu
     */

    const header = document.querySelector('header');

    if (!header) return;

    const SCROLL_THRESHOLD = 0;

    function handleScrollAndResize() {
        const scrollPosition = window.scrollY;

        if (scrollPosition > SCROLL_THRESHOLD) {
            header.classList.add('is-scrolled');
        } else {
            header.classList.remove('is-scrolled');
        }
    }

    handleScrollAndResize();

    window.addEventListener('scroll', function() {
        handleScrollAndResize();
    });

}

function initScrollTo() {
    const SCROLL_TO = document.querySelectorAll('.scroll-to');

    if(SCROLL_TO) {

        for(let i = 0; i < SCROLL_TO.length; i++) {

            console.dir(SCROLL_TO[i]);

            SCROLL_TO[i].addEventListener('click', function(e) {
                e.preventDefault();

                let target = document.querySelector(this.getAttribute('href'));

                console.log(target);

                if(target) {

                    gsap.to(window, {
                        duration: 1,
                        scrollTo: target.offsetTop+150,
                        ease: 'power2.out'
                    });
                }
            });
        }
    }
}

function initFooter() {
    new Splide( '#footerLogoCarousel', {
        type    : 'loop',
        perPage : 3,
        pagination: false,
        arrows: false,
        autoplay: true,
        interval: 5000,
        focus     : '1',
        trimSpace: true,
        gap: '15px',
        breakpoints: {
            1200: {
                perPage: 2,
            },

            767: {
                perPage: 1,
            },
        }

    } ).mount();
}

document.addEventListener("DOMContentLoaded", function() {
    initMenu();
    initFooter();
    initScrollTo();
});